import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "电影分类",
    links: [
      { name: "动作片", path: "/category/action" },
      { name: "喜剧片", path: "/category/comedy" },
      { name: "科幻片", path: "/category/scifi" },
      { name: "悬疑片", path: "/category/suspense" },
      { name: "动画片", path: "/category/animation" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { name: "品牌介绍", path: "/about" },
      { name: "联系方式", path: "/about" },
      { name: "用户口碑", path: "/about" },
    ],
  },
  {
    title: "热门推荐",
    links: [
      { name: "流浪地球3", path: "/article/article-1" },
      { name: "封神第二部", path: "/article/article-3" },
      { name: "国产动画崛起", path: "/article/article-4" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
              555电影网
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              555电影网提供555电影免费高清在线观看服务，海量全集电影不缓冲秒播放。覆盖最新院线大片、经典老片，支持高清画质免费在线点播。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2024-2026 555电影网 - 555电影免费高清在线观看。本站内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}